var pollUntil = function _PollUntil(fn) {
	if (typeof fn !== 'function') {
		throw new Error('pollUntil: polling function missing in argument');
	}
	var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3000;
	var pollInterval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 200;

	if (typeof args === 'number') {
		pollInterval = timeout;
		timeout = args;
		args = [];
	}

	var scheduler1, scheduler2;

	function clearSchedulers() {
		clearTimeout(scheduler1);
		clearTimeout(scheduler2);
	}

	const poller = new Promise(function(resolve) {
		(function poll() {
			const result = fn.apply(this, args);
			if (result) {
				resolve(result);
			} else {
				scheduler1 = setTimeout(poll, pollInterval);
			}
		}());
	});

	const timer = new Promise(function(resolve) {
		scheduler2 = setTimeout(function() {
			resolve(false);
		}, timeout);
	});

	return Promise.race([poller, timer])
		.then(function(result) {
			clearSchedulers();
			return Promise.resolve(result);
		})
		.catch(function(error) {
			clearSchedulers();
			throw new Error(error);
		});
};

module.exports = pollUntil;
